import { Navigate, Outlet } from "react-router-dom";

import { PATHS } from "../../../app/router/paths";
import { useAuth } from "../model/AuthContext";

export const RequireAnyPermission = ({ permissions }: { permissions: string[] }) => {
  const { user } = useAuth();
  return permissions.some((permission) => user?.permissions.includes(permission))
    ? <Outlet />
    : <Navigate to={PATHS.AUTH.FORBIDDEN} replace />;
};
